module.exports = __webpack_public_path__ + "img/picweb.acca22c9.png";